module.exports = __webpack_public_path__ + "83fbc90339baba70ac2a71a589820fad.pdf";